module.exports = __webpack_public_path__ + "img/bts.2fce6cca.svg";